import React from 'react';
import './DashboardStatus.css';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

function DashboardStatus({ icon, title, value, lastWeekValue }) {
  const percentageChange = lastWeekValue 
    ? ((value - lastWeekValue) / lastWeekValue * 100).toFixed(1)
    : 0;
  const isPositive = percentageChange >= 0;

  return (
    <div className='dashboard-status'>
      <div className='dashboard-status-header'>
      <div className='dashboard-status-icon'>{icon}</div>
      <span className='dashboard-status-title'>{title}</span>
      </div>
      <span className='dashboard-status-value'>{value}</span>
      {lastWeekValue !== undefined && (
        <div className={`dashboard-status-change ${isPositive ? 'positive' : 'negative'}`}>
          {isPositive ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
          {Math.abs(percentageChange)}%
          <span className='dashboard-status-change-text'>vs last week</span>
        </div>
      )}
    </div>
  );
}

export default DashboardStatus;